import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services';

@Component({
  selector: 'app-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss']
})
export class NoticesComponent implements OnInit {

  public notices: any = [];
  constructor(
      private commonService: CommonService
  ) {
    this.commonService.getNotices().subscribe(data => {
        this.notices = data;
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/notices/notices.component.ts